import { Holiday, makeBookingStartDate, validBusinessDay } from '../../atoms'
import { addHours } from 'date-fns'
import { FormFieldState } from './components'

export const defaultInquireState: FormFieldState = {
  firstName: { value: '' },
  lastName: { value: '' },
  email: { value: '' },
  phone: { value: '' },
  description: { value: '' },
  marketing: { value: false },
}

export const makeDefaultOfficeState = (buildingHolidays?: Holiday) => ({
  date: { value: { from: validBusinessDay(addHours(new Date(), 18), buildingHolidays) }, pristine: true, open: false },
})

export const defaultOfficeState = makeDefaultOfficeState()

export const makeDefaultDeskState = (buildingHolidays?: Holiday) => ({
  date: { value: { from: validBusinessDay(new Date(), buildingHolidays) }, pristine: true, open: false },
  desks: { value: { label: '1 day pass', value: '1' } },
})

export const defaultDeskState = makeDefaultDeskState()

export const makeDefaultMeetingState = (
  buildingHolidays?: Holiday,
  duration?: string | null,
  labelDuration?: string | null
) => ({
  date: {
    value: { from: makeBookingStartDate(new Date(), buildingHolidays) },
    pristine: true,
    open: false,
  },
  duration: { value: { label: labelDuration ?? '30 minutes', value: duration ?? '0.5' } },
  needsAdditionalServices: { value: false },
  additionalServices: { value: '' },
  startTime: { loading: true },
})

export const defaultMeetingState = makeDefaultMeetingState()
